import apiClient from '../api';

const API_PATH = '/users';

// Get all users (admin only)
export const getAllUsers = () => {
  return apiClient.get('/admin/users');
};

// Get user by ID
export const getUserById = (id) => {
  return apiClient.get(`${API_PATH}/${id}`);
};

// Get company users (filtered by company for company_admin)
export const getCompanyUsers = () => {
  return apiClient.get(`${API_PATH}/company`);
};

// Get company info (for company admins)
export const getCompanyInfo = () => {
  return apiClient.get(`${API_PATH}/company/info`);
};

// Create a new user
export const createUser = (userData) => {
  return apiClient.post(API_PATH, userData);
};

// Create a company user (for company admins)
export const createCompanyUser = (userData) => {
  return apiClient.post(`${API_PATH}/company`, userData);
};

// Update user information
export const updateUser = (id, userData) => {
  return apiClient.patch(`${API_PATH}/${id}`, userData);
};

// Update company user (for company admins)
export const updateCompanyUser = (id, userData) => {
  return apiClient.patch(`${API_PATH}/company/${id}`, userData);
};

// Deactivate/reactivate user
export const setUserActiveStatus = (id, isActive) => {
  return apiClient.patch(`${API_PATH}/${id}/status`, { isActive });
};

// Delete a user (if allowed)
export const deleteUser = (id) => {
  return apiClient.delete(`${API_PATH}/${id}`);
};

// Delete a company user (for company admins)
export const deleteCompanyUser = (id) => {
  return apiClient.delete(`${API_PATH}/company/${id}`);
}; 